import React from 'react';
import ExchangeAllocation from './ExchangeAllocation';
import AssetQuoteBalance from './AssetQuoteBalance';
import { SubscriptionSummary } from '../../../../types/subscription';
import './index.css';

interface BottomSectionProps {
  subscriptions: SubscriptionSummary[];
}

const BottomSection: React.FC<BottomSectionProps> = ({ subscriptions }) => {
  return (
    <div className="bottom-container">
      <ExchangeAllocation subscriptions={subscriptions} />
      <AssetQuoteBalance subscriptions={subscriptions} />
    </div>
  );
};

export default BottomSection;
